export default __webpack_public_path__ + "723e546ad96c0a121c23e651adbe7cc9.svg";